import styled from 'styled-components';

export const AddLabel = styled.div`
  color: ${({ theme }) => theme.baseBlue.a10};
  opacity: 0.65;
  font-size: 12px;
  font-weight: 600;
  width: 100%;
  cursor: pointer;
  text-transform: uppercase;
  max-width: 12%;
  > span {
    font-size: 15px;
    line-height: 0.1;
  }
  &:hover {
    color: ${({ theme }) => theme.baseBlue.a8}; 
  }
`;

export const FormButtonSection = styled.div`
  padding: 1rem 0;
  display: flex;
  justify-content: flex-end;
`;

export const FormButtonContainer = styled.div`
  margin-left: 1rem;
`;

export const FormDeleteContainer = styled.div`
  flex: 1;
`;

export const FooterSection = styled.div`
  display: flex;
  align-items: center;
`;
